

const PricingTransparency = () => {
  const pricingFactors = [
    {
      icon: 'UserIcon',
      title: 'Creator Stage',
      description: 'Pricing scales with your channel size and needs',
      multiplier: '1.0x base',
    },
    {
      icon: 'FilmIcon',
      title: 'Content Type',
      description: 'Different niches require different editing complexity',
      multiplier: '1.0x - 1.6x',
    },
    {
      icon: 'ClockIcon',
      title: 'Video Length',
      description: 'Longer videos require more editing time',
      multiplier: '1.0x - 1.8x',
    },
    {
      icon: 'FolderIcon',
      title: 'Raw Footage',
      description: 'More footage means more sorting and selection',
      multiplier: '1.0x - 1.5x',
    },
    {
      icon: 'SparklesIcon',
      title: 'Editing Style',
      description: 'Premium styles include advanced effects',
      multiplier: '1.0x - 1.7x',
    },
    {
      icon: 'ChartBarIcon',
      title: 'Monthly Volume',
      description: 'Higher volume gets better per-video pricing',
      multiplier: '0.78x - 1.0x',
    },
  ];

  return null;
};

export default PricingTransparency;